import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowPathLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconArrowPathLeft"><Path d="M21.25 12.25V11.75C21.25 10.0931 19.9069 8.75 18.25 8.75H10.25V5.32122C10.25 4.89668 9.75431 4.66531 9.42889 4.93796L2.37232 10.8502C1.65676 11.4497 1.65676 12.5503 2.37232 13.1498L9.42889 19.062C9.75431 19.3347 10.25 19.1033 10.25 18.6788V15.25H18.25C19.9069 15.25 21.25 13.9069 21.25 12.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconArrowPathLeft;
